'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var Pagination_parts = require('./Pagination.parts.js');
var Pagination_utils = require('./Pagination.utils.js');

/**
 * 페이지네이션 컴포넌트
 *
 * @description
 * 여러 페이지로 구성된 콘텐츠를 탐색할 수 있는 페이지네이션 컴포넌트입니다.
 * 좌우 화살표와 페이지 번호 버튼으로 구성되어 있으며, 현재 페이지가 강조 표시됩니다.
 *
 * @param {Object} props
 * @param {number} props.maxPage - 전체 페이지 수
 * @param {number} [props.pageCount=10] - 한 번에 표시할 페이지 버튼의 개수 (기본값: 10)
 * @param {number} props.page - 현재 페이지 번호
 * @param {(page: number) => void} props.onChange - 페이지 변경 시 호출되는 콜백 함수
 *
 * @example
 * ```tsx
 * <Pagination
 *   maxPage={100}
 *   pageCount={5}
 *   page={1}
 *   onChange={(page) => setCurrentPage(page)}
 * />
 * ```
 */ const Pagination = ({ maxPage, pageCount = 10, page, onChange })=>{
    const isFirstPage = page === 1;
    const isLastPage = page === maxPage;
    const handlePrevious = ()=>{
        if (isFirstPage) return;
        onChange(page - 1);
    };
    const handleNext = ()=>{
        if (isLastPage) return;
        onChange(page + 1);
    };
    const firstPage = Pagination_utils.getFirstPage(page, pageCount);
    const lastPage = Pagination_utils.getLastPage(firstPage, pageCount, maxPage);
    const pageButtonCount = Pagination_utils.getPageButtonCount(firstPage, lastPage);
    return jsxRuntime.jsxs("div", {
        "data-testid": "design-system-pagination",
        className: "flex items-center justify-center gap-2",
        children: [
            jsxRuntime.jsx(Pagination_parts.LeftArrow, {
                onClick: handlePrevious,
                className: tailwindMerge.twJoin('p-3', isFirstPage && 'invisible')
            }),
            Array.from({
                length: pageButtonCount
            }).map((_, index)=>{
                const pageNumber = firstPage + index;
                return jsxRuntime.jsx(Pagination_parts.PaginationNumber, {
                    "data-testid": `page-${pageNumber}`,
                    value: pageNumber,
                    enabled: pageNumber === page,
                    onClick: ()=>onChange(pageNumber)
                }, pageNumber);
            }),
            jsxRuntime.jsx(Pagination_parts.RightArrow, {
                onClick: handleNext,
                className: tailwindMerge.twJoin('p-3', isLastPage && 'invisible')
            })
        ]
    });
};

module.exports = Pagination;
